module.exports = __webpack_public_path__ + "img/hdd-stack.e6cbd185.svg";